import fb, { getDocsFromCollection } from '@/firebase'
import store from '@/store'
import router from '@/router'

const state = {
  allSchools: null,
  schools: null,
  school: null
}

const getters = {
  allSchools: state => state.allSchools,
  schools: state => state.schools,
  school: state => state.school
}

const mutations = {
  setAllSchools: (state, payload) => {
    state.allSchools = payload
  },
  setSchools: (state, payload) => {
    state.schools = payload
  },
  setSchool: (state, payload) => {
    state.school = payload
  }
}

const actions = {
  getAllSchools: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getAllSchools()
      .then((fetched) => {
        commit('setAllSchools', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getSchools: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchools()
      .then((fetched) => {
        commit('setSchools', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getSchool: ({commit}, id) => {
    store.dispatch('setLoaderStatus', true)
    fb.getSchool(id)
      .then((fetched) => {
        let docData = fetched.data()
        const data = {...docData, ...{id: fetched.id, ref: fetched.ref}}
        commit('setSchool', data)
        store.dispatch('setLoaderStatus', false)
      })
  },
  addSchool: ({commit}, payload) => {
    store.dispatch('setLoaderStatus', true)
    fb.addSchool(payload)
      .then((response) => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'School details saved successfully')
        store.dispatch('getSchools')
      })
  },
  updateSchool: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateSchool(params.id, params.payload)
      .then((response) => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'School details updated successfully')
        store.dispatch('getSchools')
        store.dispatch('getAllSchools')
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/schools.js